import React, { useState } from 'react';

export default ({ plusIcon, title, subTitle, onClick }) => {
	//
	// const [show, setShow] = useState(false);
	// handleClick = () => showPopup(true);

	return (
		<div className="lobby-item mb-3" onClick={onClick}>
			<div className="btn-top">
				<div className="title">{title}</div>
				{!plusIcon ? (
					<div className="btn-icon">
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fillRule="evenodd"
								d="M16.2396 5.51257C16.3451 5.41556 16.4705 5.3386 16.6086 5.28609C16.7466 5.23357 16.8946 5.20654 17.044 5.20654C17.1935 5.20654 17.3415 5.23357 17.4795 5.28609C17.6176 5.3386 17.743 5.41556 17.8485 5.51257L24.6662 11.7626C24.772 11.8593 24.8559 11.9743 24.9132 12.1008C24.9705 12.2274 25 12.3631 25 12.5001C25 12.6371 24.9705 12.7728 24.9132 12.8993C24.8559 13.0259 24.772 13.1408 24.6662 13.2376L17.8485 19.4876C17.6352 19.6832 17.3458 19.7931 17.044 19.7931C16.7423 19.7931 16.4529 19.6832 16.2396 19.4876C16.0262 19.292 15.9063 19.0267 15.9063 18.7501C15.9063 18.4735 16.0262 18.2082 16.2396 18.0126L22.255 12.5001L16.2396 6.98757C16.1338 6.89081 16.0498 6.77586 15.9925 6.64931C15.9352 6.52276 15.9057 6.38709 15.9057 6.25007C15.9057 6.11306 15.9352 5.97739 15.9925 5.85083C16.0498 5.72428 16.1338 5.60933 16.2396 5.51257Z"
								fill="#212121"
							/>
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M6.81763 12.5C6.81763 12.2237 6.93734 11.9588 7.15043 11.7634C7.36353 11.5681 7.65254 11.4583 7.9539 11.4583H22.7254C23.0268 11.4583 23.3158 11.5681 23.5289 11.7634C23.742 11.9588 23.8617 12.2237 23.8617 12.5C23.8617 12.7763 23.742 13.0412 23.5289 13.2366C23.3158 13.4319 23.0268 13.5417 22.7254 13.5417H7.9539C7.65254 13.5417 7.36353 13.4319 7.15043 13.2366C6.93734 13.0412 6.81763 12.7763 6.81763 12.5ZM1.13627 25C0.834913 25 0.545899 24.8903 0.332806 24.6949C0.119714 24.4996 0 24.2346 0 23.9583V1.04167C0 0.765399 0.119714 0.500448 0.332806 0.305097C0.545899 0.109747 0.834913 0 1.13627 0C1.43763 0 1.72664 0.109747 1.93974 0.305097C2.15283 0.500448 2.27254 0.765399 2.27254 1.04167V23.9583C2.27254 24.2346 2.15283 24.4996 1.93974 24.6949C1.72664 24.8903 1.43763 25 1.13627 25Z"
								fill="#212121"
							/>
						</svg>
					</div>
				) : (
					<div className="btn-icon">
						<svg
							width="25"
							height="25"
							viewBox="0 0 25 25"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M17.6339 11.6071H13.3929V7.36604C13.3929 7.24327 13.2924 7.14282 13.1696 7.14282H11.8304C11.7076 7.14282 11.6071 7.24327 11.6071 7.36604V11.6071H7.36607C7.2433 11.6071 7.14285 11.7076 7.14285 11.8303V13.1696C7.14285 13.2924 7.2433 13.3928 7.36607 13.3928H11.6071V17.6339C11.6071 17.7567 11.7076 17.8571 11.8304 17.8571H13.1696C13.2924 17.8571 13.3929 17.7567 13.3929 17.6339V13.3928H17.6339C17.7567 13.3928 17.8571 13.2924 17.8571 13.1696V11.8303C17.8571 11.7076 17.7567 11.6071 17.6339 11.6071Z"
								fill="#212121"
							/>
							<path
								d="M12.5 0C5.5971 0 0 5.5971 0 12.5C0 19.4029 5.5971 25 12.5 25C19.4029 25 25 19.4029 25 12.5C25 5.5971 19.4029 0 12.5 0ZM12.5 22.8795C6.76897 22.8795 2.12054 18.231 2.12054 12.5C2.12054 6.76897 6.76897 2.12054 12.5 2.12054C18.231 2.12054 22.8795 6.76897 22.8795 12.5C22.8795 18.231 18.231 22.8795 12.5 22.8795Z"
								fill="#212121"
							/>
						</svg>
					</div>
				)}
			</div>
			<div className={`${plusIcon ? 'inverted' : ''} btn-bot`}> {subTitle}</div>
		</div>
	);
};
